/**
 * Accessibility helpers:
 * - Keep inert in sync with aria-hidden on hotspot popovers
 * - Add titles to third-party iframes missing them
 */
(function () {
  function syncInert(el) {
    if (!(el instanceof Element)) return;
    if (el.getAttribute('aria-hidden') === 'true') {
      el.setAttribute('inert', '');
    } else {
      el.removeAttribute('inert');
    }
  }

  function observeAriaHidden(selector) {
    document.querySelectorAll(selector).forEach(syncInert);

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
          syncInert(mutation.target);
        }
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function (node) {
            if (!(node instanceof Element)) return;
            if (node.matches && node.matches(selector)) syncInert(node);
            if (node.querySelectorAll) {
              node.querySelectorAll(selector).forEach(syncInert);
            }
          });
        }
      });
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['aria-hidden'],
      childList: true,
      subtree: true,
    });
  }

  function titleUntitledIframes() {
    document.querySelectorAll('iframe:not([title])').forEach(function (iframe) {
      const id = iframe.id || '';
      if (id === 'PBarNextFrame') {
        iframe.setAttribute('title', 'Payment progress');
      } else if (!iframe.hasAttribute('title')) {
        iframe.setAttribute('title', 'Embedded content');
      }
    });
  }

  function init() {
    observeAriaHidden('hotspots-float-element');
    titleUntitledIframes();

    const iframeObserver = new MutationObserver(function () {
      titleUntitledIframes();
    });
    iframeObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
